import './UserProfile.css';
import CurrentTime from '../components/CurrentTime';
import DynamicIsland from '../components/DynamicIsland';
import Back from '../components/Back';
import { CiUser } from "react-icons/ci";
import { useNavigate } from 'react-router-dom';

function UserProfile (){

    const navigate = useNavigate();

  const handleLogout = () => {
    // Add any logout logic here, like clearing tokens or session data
    console.log('User logged out');
    navigate('/'); // Navigate to the main route
  };

    return(
        <section className="user-container"> 
            <CurrentTime/>
            <DynamicIsland/>
            <Back/>
            <div className="user-profile-icon">
                <CiUser className="user-profile-icon-second" size={"100px"}/>
            </div>
            <div className="student-name-info">
                <h1>John Doe</h1>
            </div>
            <div className="basic-information">
            <h1><strong>Basic Information</strong></h1>
                <div className="basic-information-details">
                <h3><strong>Full Name</strong></h3>
                <h3>John Doe</h3>
                <h3><strong>Email Address</strong></h3>
                <h3>student@towson.edu</h3>
                <h3><strong>Pronouns</strong></h3>
                <h3>He/Him</h3>
                </div>
            </div>
            <div className="additional-information">
                <h1><strong>Additional Information</strong></h1>
                <div className="additional-information-details">
                <h3><strong>Gender</strong></h3>
                <h3>Male</h3>
                <h3><strong>Education</strong></h3>
                <h3>B.Sc. in Information Technology</h3>
                <h3><strong>Website</strong></h3>
                <h3>towson.edu</h3>
                </div>
            </div>
            <div className="contact-information">
                <h1><strong>Contact Information</strong></h1>
                <div className="contact-information-details">
                <h3><strong>Phone Number</strong></h3>
                <h3>+1 (000)-000-0000</h3>
                </div>
            </div>
            <button className="logout-button" onClick={handleLogout}>
            Logout
            </button>
        </section>
    );
}

export default UserProfile;